<template>
	<div>
		<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
		<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
		<div class="maxContainer subscriptionPlan" v-if="getSubscriptionDetail.totalRecords > 0 && !pageLoader"> 
			<div class="mainTitle p-0 d-flex align-items-center justify-content-between text-center my-3">
				<h3 class="mb-2"> {{$t('subtrans_heading')}}</h3>

				<router-link  :to="{name: 'tools' , params: { 'tabName': 'VPS'}}" class="btn_sm prism_btn "  data-placement="top"  data-toggle="tooltip">{{$t('subtrans_backVPSlist')}}</router-link>
			</div> 
			<div class="tablePmm table-responsive mb-5">
                <table class="table pmmTable" >
                    <thead>
                        <tr>
							<th>{{$t('subtrans_date')}}</th>							
                            <th>{{$t('subtrans_payType')}}</th>
                            <th>{{$t('subtrans_planprice')}}</th>
                            <th>{{$t('subtrans_coupon')}}</th>
							<th>{{$t('subtrans_amount')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(list,index) in getSubscriptionDetail.records">
                         	<td>{{list.created  | moment("DD MMMM YYYY")}}</td>
                         	<td><p v-html="((parseInt(list.pay_type) == 0) ? 'paid' : ((parseInt(list.pay_type) == 2) ? 'loyalty points' : 'free'))"></p></td>
                         	<td>{{list.chargeable_amount}} {{list.plan_currency}}</td>
                            <td>{{list.coupon_code || '-'}}</td>
                         	<td>{{list.converted_amount}} {{list.converted_currency}}</td>
                        </tr>
                    </tbody>
                </table> 
                 <pagination :getList="getSubscriptionDetail" :limit="pageLimit" v-if="getSubscriptionDetail.totalRecords > 15"></pagination>
            </div> 
		</div>
		<div class="text-center p-5 customLoader" v-else-if="pageLoader" > 
			<h4>{{$t('dep_acc_fund_plzWaitWhileProc')}}</h4>
		</div> 
		<div class="CustomBlockWidth " v-else > 
			<div class="card ">
			  <div class="card-body text-center">
				<img src="../../../../static/fxView/images/lost.svg" alt="no account found" class="mb-4" width="200">  
				<!-- Text -->
				<span>
					<p class="text-muted mb-3" >
					  {{$t('subtrans_noData')}}
					</p>  
					 <router-link :to="{name: 'tools' , params: { 'tabName': 'VPS'}}" class="prism_btn btn_sm lift"  data-placement="top"  data-toggle="tooltip">{{$t('subtrans_backVPSlist')}}</router-link>
				</span> 
				  
			  </div>
			</div>
		</div>
	</div>
</template>
<script> 
	export default {
		name: 'VPS-Detail',
		data() {
			return {
				//============message and loader ===========
				response_msg : '',
				msg_type : '',
				pageLoader : false,
				//==========================================
				 pageLimit : '15',
                search : '',
                page : '1',
			}
		},
		methods:{
			listing(){
                let input_json={
                    'globalParams' :{
                        'subscription_id' : this.$route.query.id
                    },
                    'localParams' :{ "parameter" : this}
                }
                this._runGetSubscriptionDetail(input_json)
            },
		},
		created(){
			this.listing()
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/subsTransactionDetail.vue